<template>
  <div class="it-header-navbar-wrapper">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <nav class="navbar navbar-expand-lg has-megamenu">
            <button aria-controls="nav10" aria-expanded="false" aria-label="Toggle navigation" class="custom-navbar-toggler" data-target="#nav10" type="button">
              <svg class="icon">
                <use :xlink:href="icons.itBurger"></use>
              </svg>
            </button>
            <div class="navbar-collapsable" id="nav10">
              <div class="overlay"></div>
              <div class="close-div sr-only">
                <button class="btn close-menu" type="button">
                  <span class="it-close"></span>close
                </button>
              </div>
              <div class="menu-wrapper">
                <ul class="navbar-nav">
                  <li class="nav-item ">
                    <router-link
                      class="spacing nav-link"
                      :class="{active:activePage['home']}"
                      to="/">
                      <span>Home</span>
                    </router-link>
                  </li>
                  <li class="nav-item ">
                    <router-link
                      class="spacing nav-link"
                      :class="{active:activePage['pronunce']}"
                      to="/pronunce">
                      <span>Pronunce</span>
                    </router-link>
                  </li>
                  <li class="nav-item ">
                    <router-link
                      class="spacing nav-link"
                      :class="{active:activePage['informazioni']}"
                      to="/informazioni">
                      <span>Informazioni</span>
                    </router-link>
                  </li>
                  <li class="nav-item ">
                    <router-link
                      class="spacing nav-link"
                      :class="{active:activePage['gruppo-di-lavoro']}"
                      to="/gruppo-di-lavoro">
                      <span>Gruppo di Lavoro</span>
                    </router-link>
                  </li>
                  <li class="nav-item ">
                    <router-link
                      class="spacing nav-link"
                      :class="{active:activePage['guida-all-uso']}"
                      to="/guida-all-uso">
                      <span>Guida all'uso</span>
                    </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import sprites from 'bootstrap-italia/dist/svg/sprite.svg';

export default {
  name: 'HeaderBottom',
  data() {
    return {
      icons: {
        itSearch: `${sprites}#it-search`,
        itBurger: `${sprites}#it-burger`,
      },
      activePage: {
        home: false,
        pronunce: false,
        informazioni: false,
        sviluppatori: false,
      },
    };
  },
  mounted() {
    const currentRouteName = this.$router.currentRoute.name;
    this.activePage[currentRouteName] = true;
  },
  watch: {
    // eslint-disable-next-line object-shorthand
    '$route'(to, from) {
      this.activePage[to.name] = true;
      this.activePage[from.name] = false;
    },
  },
  methods: {
  },
  components: {
  },
};
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/layout/header/HeaderBottom.vue